function normalizeCapabilities(payload) {
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
    return null;
  }

  const modules = payload.modules;
  if (!modules || typeof modules !== "object" || Array.isArray(modules)) {
    return null;
  }

  const normalizedModules = {};
  for (const [moduleId, enabled] of Object.entries(modules)) {
    if (typeof moduleId === "string" && moduleId.length > 0) {
      normalizedModules[moduleId] = enabled === true;
    }
  }

  return {
    distributionProfile: String(payload.distributionProfile || ""),
    enforcementLocked: payload.enforcementLocked === true,
    enforcementEnabled: payload.enforcementEnabled === true,
    runtimeState: String(payload.runtimeState || "InvalidLease"),
    validationCode: String(payload.validationCode || "InvalidConfiguration"),
    lastTransitionAtUtc: payload.lastTransitionAtUtc || null,
    lastSuccessfulHeartbeatAtUtc: payload.lastSuccessfulHeartbeatAtUtc || null,
    leaseExpiresAtUtc: payload.leaseExpiresAtUtc || null,
    modules: normalizedModules,
  };
}

function hasModule(snapshot, moduleId) {
  return Boolean(snapshot?.modules?.[moduleId] === true);
}

function hasAllModules(snapshot, moduleIds) {
  if (!Array.isArray(moduleIds) || moduleIds.length === 0) {
    return true;
  }

  return moduleIds.every((moduleId) => hasModule(snapshot, moduleId));
}

function hasAnyModules(snapshot, moduleIds) {
  if (!Array.isArray(moduleIds) || moduleIds.length === 0) {
    return true;
  }

  return moduleIds.some((moduleId) => hasModule(snapshot, moduleId));
}

function isOffline(snapshot) {
  return snapshot?.runtimeState === "Offline";
}

function isDenied(snapshot) {
  if (!snapshot || snapshot.enforcementEnabled !== true) {
    return false;
  }

  return snapshot.runtimeState !== "Online" && snapshot.runtimeState !== "Offline";
}

module.exports = {
  normalizeCapabilities,
  hasModule,
  hasAllModules,
  hasAnyModules,
  isOffline,
  isDenied,
};
